import styled from '@emotion/styled';

export const RootContainer = styled.div`
  max-width: ${({ theme }) => theme.maxWidth.xl};
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  flex-grow: 1;
`;
